import { createApp } from 'vue'
import App from './App.vue'
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { createI18n } from 'vue-i18n'
import Maska from 'maska'

import {uz} from './lang/uz'
import {ru} from './lang/ru'
import {en} from './lang/en'

const messages ={
    uz,ru,en
}

const i18n = createI18n({
    locale: 'uz', 
    fallbackLocale: 'uz', 
    messages, 
})

const app = createApp(App)
.use(Maska)
.use(ElementPlusIconsVue)
.use(ElementPlus)
.use(VueCookies, { expire: '1d'})
.use(store)
.use(router)
.use(i18n)
.use( VueSplide )



for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.mount('#app')